module Meevo.Plugins.PackageLookup {
  export class PackageLookupContext extends Meevo.Components.CommonClasses.CommonContextBase {
    initializeSections(): void { }
    initializeHeader(): void { }
  }
}